import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "@/store";
import type { Dataset, DatasetFilter } from "@/types/dataset";

// Memoized base selectors
const selectDatasetState = (state: RootState) => state.dataset;

export const selectDatasets = createSelector(
  [selectDatasetState],
  (datasetState) => datasetState.datasets
);

export const selectFilters = createSelector(
  [selectDatasetState],
  (datasetState) => datasetState.filters
);

// Memoized dataset-specific selectors
export const selectDatasetById = (datasetId: string) =>
  createSelector(
    [selectDatasets],
    (datasets): Dataset | undefined => datasets[datasetId]
  );

// Memoized selector factory
const createDatasetFiltersSelector = (() => {
  const cache = new Map();
  return (datasetId: string) => {
    if (!cache.has(datasetId)) {
      cache.set(
        datasetId,
        createSelector(
          [selectFilters],
          (filters): DatasetFilter[] => filters[datasetId] || []
        )
      );
    }
    return cache.get(datasetId);
  };
})();

export const selectDatasetFilters = createDatasetFiltersSelector;
